import React, {useMemo, useState} from "react";
import {LightContainer, MyModal, MyReactTable} from "../core/input_fields";
import {maxiGet, maxiPost} from "../core/maxios";
import {dateFormat} from "../core/dateFuncs";
import Consts from "../core/consts";
import Status from "../core/status";
import {Loader, MaxBtn} from "../core/components";
import PersonList from "../user/personList";
import {OfferTypeMap, PersonTypeMap, RegistrationStatusMap} from "../core/enums";


export default function OffersShow({registeredPersons: registeredPersonsRaw, registration, offers, event, eventPermitted,loadRegistrationOffers, registeredPersonOffers, sum}) {
    const registeredPersons = registeredPersonsRaw.reduce((obj, curr) => ({...obj, [curr.registeredPerson.ID]: curr}), {})

    const [showOnlyAllowedOffers, setShowOnlyAllowedOffersRaw] = useState(localStorage.getItem("showOnlyAllowedOffers") !== "false" && offers.length > 4);
    const setShowOnlyAllowedOffers = (a) => setShowOnlyAllowedOffersRaw(() => (localStorage.setItem("showOnlyAllowedOffers", a) || true) && a);


    const ids = registeredPersonsRaw.map(a => a.registeredPerson.ID).join(",");
    useMemo(loadRegistrationOffers, [ids])
    return <>
        <LightContainer>
            <h1>
                <div style={{float: "right", marginTop: "-10px"}}>

                    {
                        offers.reduce((obj, curr) => obj + 1 + (curr.suboffers?.length || 0), 0) > 4 && <MaxBtn onClick={() => setShowOnlyAllowedOffers(!showOnlyAllowedOffers)}>Unerlaubte {showOnlyAllowedOffers ? "Ein" : "Aus"}blenden</MaxBtn>
                    }
                </div>
                Zuordnung
            </h1>
            <OfferPrint {...{offers, registeredPersons, registeredPersonOffers, event, eventPermitted, loadRegistration: loadRegistrationOffers, registration, showOnlyAllowedOffers}}/>

        </LightContainer>
        {
            sum !== null &&
            <LightContainer name={"Gesamtsumme"}>
                <b>Die Kosten für diese Meldung belaufen sich auf {Consts.money.format(sum)}.</b>
            </LightContainer>
        }
    </>
}
const now = new Date();

function OfferPrint({offers, parentOffer, registeredPersons, registeredPersonOffers, event, eventPermitted, loadRegistration, registration, showOnlyAllowedOffers}) {
    //const bookersOfAllOptions = offers.filter(({type}) => type.value === OfferTypeMap.selection).reduce((arr, offer) => [...arr, ...(registeredPersonOffers[offer.ID.toString()]?.map(({registeredPerson_ID}) => registeredPerson_ID) || [])], []);
    const bookersOfAllOptionsIDs = offers
        .filter(({type}) => type.value === OfferTypeMap.selection)
        .reduce((arr, offer) => [...arr, ...(registeredPersonOffers[offer.ID.toString()]?.map(({registeredPerson_ID}) => registeredPerson_ID) || [])], []);

    return offers.map((offer, i) => {
        const bookers = registeredPersonOffers[offer.ID.toString()] || [];
        const bookersIDs = offer.type.value === OfferTypeMap.optional ?
            registeredPersonOffers[offer.ID.toString()]?.map(({registeredPerson_ID}) => registeredPerson_ID) || [] :
            bookersOfAllOptionsIDs;
        const registeredPersonsAvailable = Object.values(registeredPersons)
            .filter(({registeredPerson}) => bookersIDs.indexOf(registeredPerson.ID) === -1 &&
                (offer.onlyOfficials === 0 || ((registeredPerson.role.value === PersonTypeMap.official && offer.onlyOfficials === 1) || (registeredPerson.role.value === PersonTypeMap.participant && offer.onlyOfficials === 2)))
            )
            .map(({registeredPerson}) => registeredPerson.person_ID)

        if ((findAllowedPersons(registeredPersons, offer).length === 0 && showOnlyAllowedOffers)) {
            //console.log(findAllowedPersons(registeredPersons, offer).length === 0 , showOnlyAllowedOffers , !offer.competition_part?.automaticAssignment, offer.competition_part?.automaticAssignment, event.isCompetition === 1 ,bookers.length === 0)
            return null;
        }

        return <>
            {
                i === 0 && offer.type.value === OfferTypeMap.selection && registeredPersonsAvailable.length > 0 && <div style={{color: "red"}}>
                    Es {registeredPersonsAvailable.length === 1 ? "muss" : "müssen"} noch {registeredPersonsAvailable.length === 1 ? "eine" : registeredPersonsAvailable.length} Person{registeredPersonsAvailable.length > 1 && "en"} in eine dieser Optionen eingebucht werden.
                    <br/>
                    <br/>
                </div>
            }
            {
                (offer.type.value !== OfferTypeMap.selection || bookers.length > 0 || registration.status.value === RegistrationStatusMap.draft) && <div style={{
                    padding: "20px", marginBottom: "20px",
                    ...(offer.type.value === OfferTypeMap.selection ?
                            {border: "2px solid var(--mainColor)", borderRadius: "8px", paddingLeft: "20px", backgroundColor: "white"} :
                            {
                                borderRadius: "8px",
                                backgroundColor: "var(--maincolorlight)",
                                "borderBottomf": "4px solid var(--mainColor)"
                            }
                    )
                }}>

                    {
                        (offer.suboffers?.length || 0) === 0 && offer.type.value !== OfferTypeMap.mandatory && registration.status.value === RegistrationStatusMap.draft && registeredPersonsAvailable.length > 0 && (event.bookingStart < now && now < event.bookingEnd || eventPermitted) &&
                        <RegisteredPersonAddWrapper {...{registeredPersons, registeredPersonsAvailable, offer, event, registration, loadRegistration}}/>
                    }
                    <h3>
                        {offer.description} ({offer.type.label})&nbsp;
                        {offer.num_bookings / offer.maxParts > 0.8 && `(${Math.max(0, offer.maxParts - offer.num_bookings)} Plätze verfügbar)`}
                    </h3>

                    {
                        (offer.suboffers?.length || 0) === 0 ? <>
                            {offer.price > 0 && Consts.moneyMax(offer.price)}
                            {
                                now < event.prebookingEnd && offer.discountedPrice != null &&
                                <>, bis {dateFormat(event.prebookingEnd)} nur {Consts.moneyMax(offer.discountedPrice)}</>
                            }
                            <br/>
                            <br/>
                            {
                                offer.type.value !== OfferTypeMap.mandatory ? <>
                                    {/*gebucht für:*/}

                                    <MyReactTable
                                        data={bookers.map((booking) => ({
                                                ...booking,
                                                ...registeredPersons[booking.registeredPerson_ID]
                                            })
                                        )}
                                        columns={[
                                            {
                                                Header: "Name",
                                                accessor: "person.fullname",
                                            },
                                            {
                                                Header: "Kosten",
                                                accessor: "price",
                                                show: bookers.some(a => a.price > 0),
                                                Cell: ({value}) => Consts.moneyMax(value ?? (now < event.prebookingEnd && offer.discountedPrice != null ? offer.discountedPrice : offer.price))
                                            },
                                            {
                                                Cell: ({original}) => <em onClick={() => {
                                                    maxiPost(`/registration/${registration.ID}/delete_person_from_offer`, {registeredPerson_ID: original.registeredPerson_ID, offer_ID: offer.ID},).then(() => {
                                                        loadRegistration()
                                                    })
                                                }
                                                }>löschen</em>,
                                                maxWidth: 250,
                                                show: registration.status.value === RegistrationStatusMap.draft,
                                            }
                                        ]}
                                    />
                                </> : <>
                                    Pflicht für alle
                                </>
                            }
                        </> : <>

                        </>
                    }
                    {offer.suboffers && <OfferPrint {...{offers: offer.suboffers, registeredPersons, event, eventPermitted, registration, registeredPersonOffers, loadRegistration, showOnlyAllowedOffers}}/>}
                </div>
            }
        </>
    })
}


function findAllowedPersons(registeredPersons, offer) {
    return Object.values(registeredPersons).filter(({registeredPerson, person}) => {

            //console.log(offer.onlyOfficials === 0 , (registeredPerson.role.value === PersonTypeMap.official && offer.onlyOfficials === 1) , (registeredPerson.role.value === PersonTypeMap.participant && offer.onlyOfficials === 2) ,
            // offer.isCompetitionPart === false ,offer.minAge <= person.age , person.age <= offer.maxAge, ["W", "M"][person.sex] === offer.allowedSex)
            return (offer.onlyOfficials === 0 || ((registeredPerson.role.value === PersonTypeMap.official && offer.onlyOfficials === 1) || (registeredPerson.role.value === PersonTypeMap.participant && offer.onlyOfficials === 2))) &&
                (offer.isCompetitionPart === false || (offer.minAge <= person.age && person.age <= offer.maxAge && (["W", "M"][person.sex] === offer.allowedSex || !["M", "W"].includes(offer.allowedSex))))
        }
    )
}


function RegisteredPersonAddWrapper({registeredPersons, registeredPersonsAvailable, offer, event, registration, loadRegistration}) {
    const persons = findAllowedPersons(registeredPersons, offer).sort((a, b) => a.person.fullname < b.person.fullname ? -1 : 1)


    return <div style={{float: "right", marginTop: -5}}>
        <MyModal trigger={<MaxBtn>Person hinzufügen ({persons.length})</MaxBtn>}> {/*.filter(p => registeredPersonsAvailable.includes(p.ID))*/}

            <RegisteredPersonsAdd {...{
                persons,
                personsAvailable: registeredPersonsAvailable,
                offer, registration, event,
                reload: loadRegistration
            }}/>

        </MyModal>
    </div>
}

function RegisteredPersonsAdd({persons, personsAvailable, offer, registration, close, reload}) {

    const [{error, loading, success}, setStatusVar] = useState({});

    const handleSubmit = (person) => {
        !loading && maxiPost(`/registration/${registration.ID}/add_person_to_offer`, {offer_ID: offer.ID, registeredPerson_ID: person.registeredPerson_ID}, {setStatusVar})
            .then(() => {
                reload && reload()
            })
    }
    return <LightContainer name={"Person hinzufügen"}>
        <Status type={"error"} text={error}/>
        <PersonList
            persons={Object.values(persons).map(({person, registeredPerson}) => ({...person, registeredPerson_ID: registeredPerson.ID}))}
            nameCell={({original, value}) => personsAvailable.includes(original.ID) ? <em onClick={() => {
                handleSubmit(original)
            }}>{value} (hinzufügen)</em> : <>{value} (bereits ausgewählt)</>}
            error={""}
            loadPersons={() => null}
            match={{}}
            loading={false}
        />
    </LightContainer>
}
